import * as React from 'react'
import { Link } from 'react-router-dom'
import { ISettingDirectory, ISettingsGroup } from '../../types/global-settings'
import ArrowRight from '../icons/ui/ArrowRight'

const SettingDirectory = (props: ISettingDirectory) => {
  return (
    <Link to={props.href} className='flex mb1 p1 bg-light-grey2 border-radius justify-between items-center'>
      <span className='h6 font-blue-grey bold'>{props.label}</span>
      <ArrowRight className='svg-blue-grey mr1' height={11} width={7} />
    </Link>
  )
}

const SettingsGroup = (props: ISettingsGroup) => {
  return (
    <div className='mb3'>
      <div className='uppercase weight-600 h6 font-grey mb2'>{props.title}</div>
      <div>
        {props.directories.map((directory: ISettingDirectory, index: number) => (
          <SettingDirectory key={`settings_directory_${props.title}_${index}`} {...directory} />
        ))}
      </div>
    </div>
  )
}

export default SettingsGroup



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingsGroups.tsx